
/**
 * 주문 타입
 */
export type OrderListResponseOrdersItemOrderType = typeof OrderListResponseOrdersItemOrderType[keyof typeof OrderListResponseOrdersItemOrderType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderListResponseOrdersItemOrderType = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  ONE_TIME: 'ONE_TIME',
} as const;
